import { PreloadingStrategy, Route } from "@angular/router";
import { Observable } from "rxjs/Observable";
import { of } from "rxjs/observable/of";

export class PreloadSelectedModulesList implements PreloadingStrategy {
  preload(route: Route, load: Function): Observable<any> {
    return route.data && route.data.preload ? load() : of(null);
  }
}


// WEBPACK FOOTER //
// C:/Users/user/Desktop/otojet-git/OtojetUI-Spring-Admin-Project/src/app/preload-selected-modules-list.ts